// LEGGERA FLOW - dati del test (tutto in italiano, calcolato nel browser)

export const SAFETY_QUESTIONS = [
  {
    id: "s1",
    section: "safety",
    text:
      "Negli ultimi giorni hai notato una sola gamba gonfia all'improvviso (non entrambe), con dolore, calore o arrossamento al polpaccio?",
  },
  {
    id: "s2",
    section: "safety",
    text:
      "Oltre al gonfiore, senti dolore al petto durante l'attività?",
  },
  {
    id: "s3",
    section: "safety",
    text:
      "Hai dolore addominale forte, sangue nelle feci o perdita di peso senza motivo?",
  },
  {
    id: "s4",
    section: "safety",
    text: "Sei in gravidanza o allattamento?",
  },
];

// Opzioni sì/no per il filtro di sicurezza
export const SAFETY_OPTIONS = [
  { id: "yes", label: "Sì", danger: true },
  { id: "no", label: "No", danger: false },
];

// p() crea i punteggi profilo in modo compatto
const p = (R = 0, D = 0, P = 0) => ({ R, D, P });

export const PROFILE_QUESTIONS = [
  {
    id: "pq1",
    section: "profile",
    text: "Dove senti di più il gonfiore?",
    options: [
      { id: "a", label: "Pancia", points: p(0, 2, 0) },
      { id: "b", label: "Gambe, caviglie, piedi", points: p(2, 0, 0) },
      { id: "c", label: "Pancia e zona bacino/lombare rigida", points: p(0, 0, 2) },
      { id: "d", label: "Un po' ovunque", points: p(1, 1, 1) },
    ],
  },
  {
    id: "pq2",
    section: "profile",
    text: "Quando peggiora?",
    options: [
      { id: "a", label: "Subito dopo i pasti", points: p(0, 2, 0) },
      { id: "b", label: "A fine giornata o la sera", points: p(2, 0, 0) },
      { id: "c", label: "Dopo ore seduta", points: p(0, 0, 2) },
      { id: "d", label: "Nessun orario preciso", points: p() },
    ],
  },
  {
    id: "pq3",
    section: "profile",
    text: "Come sono le gambe a fine giornata?",
    options: [
      { id: "a", label: "Leggere", points: p() },
      { id: "b", label: "Un po' pesanti", points: p(1, 0, 0) },
      { id: "c", label: "Molto pesanti o gonfie", points: p(2, 0, 0) },
    ],
  },
  {
    id: "pq4",
    section: "profile",
    text: "Quante ore stai seduta al giorno?",
    options: [
      { id: "a", label: "Meno di 3", points: p() },
      { id: "b", label: "Tra 3 e 6", points: p(0, 0, 1) },
      { id: "c", label: "Più di 6", points: p(0, 0, 2) },
    ],
  },
  {
    id: "pq5",
    section: "profile",
    text: "Come ti senti dopo i pasti?",
    options: [
      { id: "a", label: "Nessun fastidio", points: p() },
      { id: "b", label: "Sonnolenza e pesantezza", points: p(0, 1, 0) },
      { id: "c", label: "Pancia tesa e aria", points: p(0, 2, 0) },
    ],
  },
  {
    id: "pq6",
    section: "profile",
    text: "Come mangi di solito?",
    options: [
      { id: "a", label: "Con calma", points: p() },
      { id: "b", label: "Di fretta o davanti al telefono", points: p(0, 1, 0) },
      { id: "c", label: "Salto pasti e poi mangio tanto", points: p(0, 2, 0) },
    ],
  },
  {
    id: "pq7",
    section: "profile",
    text: "Quanta acqua bevi?",
    options: [
      { id: "a", label: "Più di 1,5 litri", points: p() },
      { id: "b", label: "Tra 1 e 1,5 litri", points: p(1, 0, 0) },
      { id: "c", label: "Meno di 1 litro", points: p(2, 0, 0) },
    ],
  },
  {
    id: "pq8",
    section: "profile",
    text: "Il gonfiore cambia col ciclo?",
    options: [
      { id: "a", label: "No", points: p() },
      { id: "b", label: "Un po'", points: p(1, 0, 0) },
      {
        id: "c",
        label: "Molto, peggiora prima del ciclo",
        points: p(2, 0, 0),
        flag: "ciclo",
      },
      {
        id: "d",
        label: "Sono in menopausa o non ho il ciclo",
        points: p(),
        menopause: true,
      },
    ],
  },
  {
    id: "pq9",
    section: "profile",
    text: "Quante volte ti alleni a settimana?",
    subtitle: "Palestra, corsa, camminata veloce, corsi, allenamento a casa",
    options: [
      { id: "a", label: "3 volte o più", points: p() },
      { id: "b", label: "1-2 volte", points: p(0, 0, 1) },
      { id: "c", label: "Mai o quasi mai", points: p(1, 0, 2) },
    ],
  },
  {
    id: "pq10",
    section: "profile",
    text: "Senti rigidità a bacino, lombare o respiro corto?",
    options: [
      { id: "a", label: "No", points: p() },
      { id: "b", label: "A volte", points: p(0, 0, 1) },
      { id: "c", label: "Spesso", points: p(0, 0, 2) },
    ],
  },
  {
    id: "pq11",
    section: "profile",
    text: "Stress e sonno?",
    options: [
      { id: "a", label: "Stress e sonno vanno bene", points: p() },
      { id: "b", label: "Sono stressata, ma dormo bene", points: p(0, 1, 0) },
      { id: "c", label: "Dormo male, ma lo stress è basso", points: p(1, 0, 0) },
      { id: "d", label: "Sono stressata e dormo male", points: p(1, 1, 0) },
    ],
  },
];

export const LEVEL_QUESTIONS = [
  {
    id: "lq1",
    section: "level",
    text: "Da 1 a 10, quanto ti dà fastidio il gonfiore?",
    options: [
      { id: "a", label: "Poco", hint: "1 - 3", level: 0 },
      { id: "b", label: "Abbastanza", hint: "4 - 6", level: 1 },
      { id: "c", label: "Molto", hint: "7 - 10", level: 2 },
    ],
  },
  {
    id: "lq2",
    section: "level",
    text: "Quanti giorni a settimana lo senti?",
    options: [
      { id: "a", label: "1 - 2 giorni", level: 0 },
      { id: "b", label: "3 - 4 giorni", level: 1 },
      { id: "c", label: "5 - 7 giorni", level: 2 },
    ],
  },
  {
    id: "lq3",
    section: "level",
    text: "Da quanto tempo lo hai?",
    options: [
      { id: "a", label: "Meno di 1 mese", level: 0 },
      { id: "b", label: "Da 1 a 6 mesi", level: 1 },
      { id: "c", label: "Più di 6 mesi", level: 2 },
    ],
  },
];

export const ALL_QUESTIONS = [
  ...SAFETY_QUESTIONS,
  ...PROFILE_QUESTIONS,
  ...LEVEL_QUESTIONS,
];

// Contenuti della pagina risultato
export const PROFILE_CONTENT = {
  R: {
    name: "Gonfiore da ritenzione e microcircolo",
    text:
      "Il tuo gonfiore sembra legato alla ritenzione di liquidi e a un microcircolo un po' pigro. Si sente di più su gambe, caviglie e piedi e tende a peggiorare a fine giornata. È una situazione molto comune e con cui si può lavorare: movimento, idratazione e piccoli gesti quotidiani possono fare davvero la differenza.",
  },
  D: {
    name: "Gonfiore addominale e digestivo",
    text:
      "Il tuo gonfiore sembra partire soprattutto dalla pancia e dalla digestione. Si fa sentire dopo i pasti, con pesantezza o aria, e spesso dipende dal modo e dai tempi in cui mangi. La buona notizia è che risponde bene ad abitudini semplici: mangiare con più calma e attenzione può alleggerirti già in poco tempo.",
  },
  P: {
    name: "Gonfiore da sedentarietà e postura",
    text:
      "Il tuo gonfiore sembra legato soprattutto alle tante ore passate sedute e a una certa rigidità di bacino, schiena e respiro. Quando il corpo si muove poco, anche il gonfiore fatica a scorrere via. Riattivare il corpo con pause, movimento e respirazione può aiutarti a sentirti più leggera e sciolta.",
  },
};

export const SECONDARY_NOTE = {
  R: "Nel tuo profilo c'è anche una componente di ritenzione e microcircolo: alcuni consigli pensati per le gambe e l'idratazione potranno esserti utili.",
  D: "Nel tuo profilo c'è anche una componente digestiva: fare più attenzione al modo e ai tempi dei pasti può aiutarti.",
  P: "Nel tuo profilo c'è anche una componente di sedentarietà e postura: inserire più movimento e pause nella giornata può darti una mano.",
};

export const CICLO_NOTE =
  "Hai notato che il gonfiore cambia con il ciclo: è normale. Nei giorni prima delle mestruazioni gli ormoni favoriscono la ritenzione di liquidi, quindi può accentuarsi, per poi attenuarsi con l'arrivo del ciclo.";

export const R_MEDICAL_NOTE =
  "Se le gambe restano gonfie anche al mattino, dopo il riposo, o il gonfiore non migliora mai, parlane con il tuo medico.";

export const DISCLAIMER =
  "Questo test non è una diagnosi e non sostituisce il parere di un medico.";

const PROFILE_ORDER = ["R", "D", "P"];
const QUESTION_WEIGHT = { pq1: 1.5, pq2: 1.5 };
const weightOf = (id) => QUESTION_WEIGHT[id] || 1;

// Profilo indicato dalla domanda 1 (poi dalla 2) per la parità esatta
function indicatedProfile(answers) {
  const map = { a: "D", b: "R", c: "P" }; // a=pancia→D, b=gambe→R, c=bacino→P
  const o1 = answers["pq1"];
  if (o1 && map[o1.id]) return map[o1.id]; // "d" (Un po' ovunque) → passa alla domanda 2
  const o2 = answers["pq2"];
  if (o2 && map[o2.id]) return map[o2.id];
  return null;
}

export function computeResult(answers) {
  const totals = { R: 0, D: 0, P: 0 };
  const maxScore = { R: 0, D: 0, P: 0 };
  let flagCiclo = false;
  let menopause = false;

  const cicloOpt = answers["pq8"];
  if (cicloOpt && cicloOpt.menopause) menopause = true;
  if (cicloOpt && cicloOpt.flag === "ciclo") flagCiclo = true;

  for (const q of PROFILE_QUESTIONS) {
    const w = weightOf(q.id);
    const opt = answers[q.id];

    for (const key of PROFILE_ORDER) {
      // In menopausa: la domanda sul ciclo non conta nel massimo del profilo R
      if (menopause && q.id === "pq8" && key === "R") continue;
      const bestForQ = Math.max(...q.options.map((o) => o.points[key]));
      maxScore[key] += bestForQ * w;
      if (opt) totals[key] += opt.points[key] * w;
    }
  }

  const pct = {};
  for (const key of PROFILE_ORDER) {
    pct[key] = maxScore[key] > 0 ? totals[key] / maxScore[key] : 0;
  }

  let ranked = PROFILE_ORDER.map((key) => ({ key, score: totals[key], pct: pct[key] }));
  ranked.sort((a, b) => b.pct - a.pct || b.score - a.score);

  // Parità esatta tra le prime due percentuali
  if (Math.abs(ranked[0].pct - ranked[1].pct) < 1e-9) {
    const topPct = ranked[0].pct;
    const tied = ranked.filter((r) => Math.abs(r.pct - topPct) < 1e-9);
    const ind = indicatedProfile(answers);
    let winnerKey;
    if (ind && tied.some((t) => t.key === ind)) winnerKey = ind;
    else winnerKey = tied.slice().sort((a, b) => b.score - a.score)[0].key;
    ranked = [ranked.find((r) => r.key === winnerKey), ...ranked.filter((r) => r.key !== winnerKey)];
  }

  const primary = ranked[0];
  const second = ranked[1];
  const isMixed = second.pct > 0 && primary.pct - second.pct <= 0.08 + 1e-9;

  // Livello (invariato)
  let levelScore = 0;
  for (const q of LEVEL_QUESTIONS) {
    const opt = answers[q.id];
    if (opt) levelScore += opt.level;
  }
  let level = "Lieve";
  if (levelScore >= 5) level = "Alto";
  else if (levelScore >= 3) level = "Medio";

  return {
    profile: primary.key,
    profileName: PROFILE_CONTENT[primary.key].name,
    profileText: PROFILE_CONTENT[primary.key].text,
    level,
    mixed: isMixed,
    secondary: isMixed ? second.key : null,
    secondaryName: isMixed ? PROFILE_CONTENT[second.key].name : null,
    flagCiclo,
    percentages: {
      R: Math.round(pct.R * 100),
      D: Math.round(pct.D * 100),
      P: Math.round(pct.P * 100),
    },
  };
}
